module.exports = __webpack_public_path__ + "img/logo-black.bf77a35b.png";